module.exports = require("/codebuild/output/src2004374030/src/src/store")